import { Button, Form, Select, Slider } from 'antd'
import React, { useContext, useEffect } from 'react'
import styled from 'styled-components';
import { AppSettingsContext } from '../../App/AppSettingsContextContainer';
import { MapContext } from '../../App/MapContextContainer';
import { numberToPastDate } from '../../pages/utils';
import CustomSliderWithLabels from './CustomSliderWithLabels';
import { useTranslation } from 'react-i18next';
const { Option } = Select;

export const SliderWithBottomPadding = styled(Slider)`
    padding-bottom: 2em;
`;

export const reduceOptionValues = (values: string[]) => {
    return values.reduce((prev, curr) => {
        return prev + (prev ? "," : "") + curr;
    }, "");
};

export const formatMonthTooltip = (stuff?: number) => {
    const pastDate = numberToPastDate(stuff);

    if (pastDate) {
        return pastDate.getMonth() + 1 + "/" + pastDate.getFullYear();
    }
};

interface IProps {
    isArrivalMonthFilterEnabled?: boolean,
    isAgeFilterEnabled?: boolean,
    hideTooltips?: boolean,
    getDeclarationsSinceMonths?: number,
    singleSidedDeclarationSlider?: boolean
}

export default function Filters(props: IProps) {
    const [form] = Form.useForm();
    const mapContext = useContext(MapContext);
    const appSettingsContext = useContext(AppSettingsContext);
    const { t, i18n } = useTranslation("sidePanelTabs");

    const isArrivalMonthFilterEnabled: boolean = props.isArrivalMonthFilterEnabled === true;
    const isAgeFilterEnabled: boolean = props.isAgeFilterEnabled === true;
    const hideTooltips: boolean = props.hideTooltips === true;

    useEffect(() => {
        if (appSettingsContext.appliedFilters !== undefined) {
            form.setFieldsValue(appSettingsContext.appliedFilters);
        }
    }, [appSettingsContext.appliedFilters]);

    const onFinish = (values: any) => {
        appSettingsContext.setAppliedFilters(values);
    };

    const onReset = () => {
        form.resetFields();

        appSettingsContext.setAppliedFilters(undefined);
    };

    return (mapContext.legendData && <div>
        <Form form={form} name="control-hooks" onFinish={onFinish} layout={'vertical'}>
            <Form.Item
                name="IKA"
                label={t("puustonIkä")}
            >
                <CustomSliderWithLabels initialMinVal={appSettingsContext.appliedFilters?.IKA?.at(0)}
                    initialMaxVal={appSettingsContext.appliedFilters?.IKA?.at(1)}
                    valueType='NUMBER' disabled={!isAgeFilterEnabled} minVal={0} maxVal={200} />
            </Form.Item>
            {isArrivalMonthFilterEnabled && <Form.Item
                name="declarationArrivalMonths"
                label={t("ilmoituksenTuloKuukausi")}
            >
                <CustomSliderWithLabels valueType='DATE'
                    initialMinVal={appSettingsContext.appliedFilters?.declarationArrivalMonths?.at(0)}
                    initialMaxVal={appSettingsContext.appliedFilters?.declarationArrivalMonths?.at(1)}
                    disabled={!isArrivalMonthFilterEnabled} minVal={-(props.getDeclarationsSinceMonths || 36)} maxVal={0} singleSidedDeclarationSlider />
            </Form.Item>}
            <Form.Item
                name="cuttingRealizationPractices"
                label={t("hakkuunToteutusTapa")}
            >
                <Select
                    placeholder={t("valitsePlaceHolder")}
                    allowClear
                    onFocus={() => window.blur()}
                    mode='multiple'
                >
                    {
                        mapContext.legendData?.map((legendItem: any) => (
                            <Option value={reduceOptionValues(legendItem.values)} key={legendItem.label}>{i18n.language === "en" ? legendItem.label_en : legendItem.label}</Option>
                        ))
                    }
                </Select>
            </Form.Item>
            {/* <Form.Item
                name="TILA"
                label="Ilmoituksen tila"
            >
                <Select
                    placeholder="Valitse..."
                    allowClear
                    onFocus={() => window.blur()}
                    mode='multiple'
                >
                    <Option value={10} key={10}>10</Option>
                    <Option value={20} key={20}>20</Option>
                    <Option value={30} key={30}>30</Option>
                    <Option value={40} key={40}>40</Option>
                    <Option value={50} key={50}>50</Option>
                </Select>
            </Form.Item> */}
            <Form.Item>
                <Button type="primary" htmlType="submit">
                    {t("käytäNappula")}
                </Button>
                <Button htmlType="button" onClick={onReset}>
                    {t("tyhjennäNappula")}
                </Button>
            </Form.Item>
        </Form>
    </div >
    )
}
